// extracted by mini-css-extract-plugin
module.exports = {"emoji":"Emoji__emoji___3cGZT"};